import React from 'react';
import FormEdit from '../../common/CommonComponents/FormEdit';
import { StorageOutlined } from '@material-ui/icons';

export default function Termination({ data, showTermination, setShowTermination, setPopUp, serverTerminationList, setSelectServer }) {
    return (
        <>
            {data.caas_productName === "Genwizard Agent" ?
                <FormEdit show={showTermination} title={"Select Instance"} width={'420px'} height={'340px'} setShow={setShowTermination} saveTitle={'Delete'} saveFunction={setPopUp} saveDisabled={serverTerminationList.length === 0}>
                    <div>
                        <form id='editTags' className='formDataEdit'>
                            {data.caas_appcore && (
                                data.caas_appcore.split(',').map((item, cntr) => (
                                    <div className='instanceDisplay'>
                                        <input type="checkbox" name={item} value={item}
                                            checked={serverTerminationList.includes(item) ? true : false}
                                            onChange={(e) => setSelectServer(e.target)}
                                            style={{ margin: '5px 10px', accentColor: '#7500C0' }}
                                        />
                                        <StorageOutlined style={{ color: '#7500C0', width: '30px' }} />
                                        <label style={{ marginLeft: '10px', fontSize: '.9rem' }}>{item}</label>
                                        <label style={{ position: 'absolute', right: '10px', fontSize: '.8rem' }}>Running</label>
                                    </div>
                                ))
                            )
                            }
                        </form>
                    </div>
                </FormEdit>
                :
                <FormEdit show={showTermination} title={"Warning"} width={'420px'} height={'260px'} setShow={setShowTermination} saveTitle={'Delete'} saveFunction={setPopUp}>
                    <div style={{padding:'20px'}}>
                        <p style={{fontWeight:'500', fontSize:'1em', textAlign:'center'}}>
                            Terminating this instance cannot be undone.<br/>Please make sure you no longer need this instance before proceeding.
                        </p>
                    </div>
                </FormEdit>
            }
        </>
    )
}
